export var valuesDiagramType = ["None", "Bar", "Pie", "Line", "Radar", "Chord", "Sunburst", "Tree", "Pictorial", "PictorialBar", "Gauge", "Datatable", "Map"];
//# sourceMappingURL=DiagramType.js.map